/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { CornCooker } from "./modelCornCooker";

class ControllerCornCooker extends ControllerModel {
  constructor() {
    super("ControllerCornCooker");
    
    this.setNewNode = (callback) => {
      let vasteurization = new CornCooker();
      vasteurization.decorate(callback);

      this.addNode(vasteurization);
    }

    this.loadNode = (node, callback) => {
      let vasteurization = new CornCooker();
      vasteurization.copyFrom(node);
      vasteurization.decorate(callback);
      this.addNode(vasteurization)
    }

    this.getProperties = async (node) => {
      let n = new CornCooker();
      await n.copyFrom(node);
      return n.data
  }

  this.getNode = (node) => {
      let n = new CornCooker();
      n.copyFrom(node);
      return n
  }
  }
}

export { ControllerCornCooker };
